import { FeatureToggleMap } from '../constants/toggles';

export class FeatureToggleService {
  public static isToggleEnabled(toggle: string): boolean {
    return !!FeatureToggleMap[toggle];
  }
}